// Виджет формы, перенаправляющей на путь-адрес вида /action/key1/value1/key2/value2/.
// Поля с непустыми значениями становятся парами ключ/значение в пути, пустые игнорируются.
export default function pathFormSubmit(element) {
    element.addEventListener("submit", function (event) {
        event.preventDefault();

        const action = new URL(element.getAttribute("action") || ".", window.location.href);
        let pathname = action.pathname;

        if (!pathname.endsWith("/")) {
            pathname += "/";
        }

        const formData = new FormData(element);
        for (const [key, value] of formData.entries()) {
            const trimmed = typeof value === "string" ? value.trim() : "";
            if (trimmed === "") {
                continue;
            }
            pathname += encodeURIComponent(key) + "/" + encodeURIComponent(trimmed) + "/";
        }

        window.location.assign(pathname);
    });
}
